import { Component, OnInit, Input, OnDestroy, OnChanges } from '@angular/core';
import { AerovaleDetalle } from '@shared/models/despacho/AerovaleDetalle';
import { TipoPago } from '@shared/enums/tipoPago';
import { DomSanitizer } from '@angular/platform-browser';
import { EstadoAerovale } from '@shared/enums/estadoAerovale';
import { EstadoPruebaLaboratorio } from '@shared/enums/estadoPruebaLaboratorio';
import { TipoVuelo } from '@shared/enums/tipoVuelo';
import { Observacion } from '@shared/models/despacho/Observacion';
import { TipoAerovale } from '@shared/enums/tipoAerovale';
import { Laboratorio } from '@shared/models/despacho/Laboratorio';
import { Subscription } from 'rxjs';
import { RanchoService } from '../rancho.service';
import html2canvas from 'html2canvas';

@Component({
  selector: 'app-ranchos-remitos-detalle', // Corregido: 'app-ranchos-remitos'
  templateUrl: './ranchos-remitos-detalle.component.html',
  styleUrls: ['./ranchos-remitos-detalle.component.css']
})
export class RanchosRemitosDetalleComponent implements OnInit, OnDestroy, OnChanges {

  @Input() aerovaleDetalle: AerovaleDetalle;

  mostrarComentario = false;
  mostrarDDJJGranel = false;

  TipoVuelo = TipoVuelo;
  TipoAerovale = TipoAerovale;
  ObserNormal: Observacion[] = [];
  ObserAnulado: Observacion[] = [];
  laboratorios: Laboratorio[]=[];

  subject$: Subscription;

  constructor(
    private sanitizer: DomSanitizer,     
    private ranchoService: RanchoService
  ) { 
    this.subject$ = this.ranchoService.getCapturarAerovaleAnulado()
      .subscribe((resp) => this.capturarImagenAerovale(resp));
  }

  operadorImagePath;
  clienteImagePath;

  // hooks

  ngOnInit() {
    if (this.aerovaleDetalle) {
      this.generarResourceUrls();
    }
    //this.armarObservaciones();
  }

  ngOnDestroy(): void {
    this.subject$.unsubscribe();
  }

  ngOnChanges(): void {
    //Called before any other lifecycle hook. Use it to inject dependencies, but avoid any serious work here.
    //Add '${implements OnChanges}' to the class.
    if (this.aerovaleDetalle) {
      this.generarResourceUrls();
    }
  }

  // armado de campos

  armarObservaciones() {
    let j = 0;
    let h = 0;
    if (this.aerovaleDetalle.observaciones != null){
      for (let i = 0; this.aerovaleDetalle.observaciones.length > i; i++) {
        if (this.aerovaleDetalle.observaciones[i].tipoObservacion == 0) {
          this.ObserNormal[j] = this.aerovaleDetalle.observaciones[i];
          j += j;
        } else {
          this.ObserAnulado[h] = this.aerovaleDetalle.observaciones[i];
          h += h;
        }
      }
    }
  }


  generarResourceUrls() {
    this.operadorImagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.aerovaleDetalle.firmaOperador);
    this.clienteImagePath = this.sanitizer.bypassSecurityTrustResourceUrl('data:image/png;base64,' + this.aerovaleDetalle.firmaCliente);
  }

  ImagenFirmaOperador(): string {
    let firma: string = ""
    if (this.aerovaleDetalle.firmaOperador != null && this.aerovaleDetalle.firmaOperador != "") { firma = this.operadorImagePath; }
    if (this.aerovaleDetalle.pathFirmaOperador != null && this.aerovaleDetalle.pathFirmaOperador != "") { firma = this.aerovaleDetalle.pathFirmaOperador; }
    return firma;
  }

  ImagenFirmaCliente(): string {
    let firma: string = ""
    if (this.aerovaleDetalle.firmaCliente != null && this.aerovaleDetalle.firmaCliente != "") { firma = this.clienteImagePath; }
    if (this.aerovaleDetalle.pathFirmaCliente != null && this.aerovaleDetalle.pathFirmaCliente != "") { firma = this.aerovaleDetalle.pathFirmaCliente; }
    return firma;
  }

  esAevReemplazo() {
    if(this.aerovaleDetalle)
      return Number(this.aerovaleDetalle.prefijo) >=900
    else 
      return null;    
  }

  obtenerAforadorInicioDeAerovale() {
    /* 0: AerovaleAerocombustible | 1: AerovaleAeroespecialidad | 2: AerovaleCombustible | 3: AerovaleAlije | 4: Servicio | 5: Devolucion */
    let resultado = 0;
    if (this.aerovaleDetalle.tipoAerovale == TipoAerovale.Aerocombustible || this.aerovaleDetalle.tipoAerovale == TipoAerovale.Devolucion) {
      resultado = this.aerovaleDetalle.detalleAerocombustible.aforadorInicio;
    }
    return resultado;
  }
  
  obtenerAforadorFinDeAerovale() {
    /* 0: AerovaleAerocombustible | 1: AerovaleAeroespecialidad | 2: AerovaleCombustible | 3: AerovaleAlije | 4: Servicio | 5: Devolucion */
    let resultado = 0;
    if (this.aerovaleDetalle.tipoAerovale == TipoAerovale.Aerocombustible || this.aerovaleDetalle.tipoAerovale == TipoAerovale.Devolucion) {
      resultado = this.aerovaleDetalle.detalleAerocombustible.aforadorFinal;
    }      
    return resultado;
  }

  mostrarFirma(): boolean {
    let mostrar: boolean = false;
    mostrar = (EstadoAerovale[this.aerovaleDetalle.estado] == EstadoAerovale.Finalizado || 
              EstadoAerovale[this.aerovaleDetalle.estado] == EstadoAerovale.FinalizadoSinFirma || 
              EstadoAerovale[this.aerovaleDetalle.estado] == EstadoAerovale.Sincronizado ||
              EstadoAerovale[this.aerovaleDetalle.estado] == EstadoAerovale.Anulado);
    return mostrar;
  }

  esAlije() {
    return this.aerovaleDetalle.tipoAerovale == TipoAerovale.Alije;
  }

  esAerovaleAdjuntado() {
    let es: boolean = false;

    let nombreArchivoOperador: string = 'o';
    let nombreArchivoCliente: string = 'c';
    if (this.aerovaleDetalle.pathFirmaOperador != null) {
      const pos1: number = this.aerovaleDetalle.pathFirmaOperador.indexOf('_');
      const posFinal1: number = this.aerovaleDetalle.pathFirmaOperador.indexOf('?')
      nombreArchivoOperador = this.aerovaleDetalle.pathFirmaOperador.substring(pos1, posFinal1);
    }
    if (this.aerovaleDetalle.pathFirmaCliente != null) {
      const pos2: number = this.aerovaleDetalle.pathFirmaCliente.indexOf('_');
      const posFinal2: number = this.aerovaleDetalle.pathFirmaCliente.indexOf('?')
      nombreArchivoCliente = this.aerovaleDetalle.pathFirmaCliente.substring(pos2, posFinal2);
    }
    es = nombreArchivoCliente.toString() === nombreArchivoOperador.toString();
    return es;
  }


  // getters

  getLaboratorio(codigo:string): string
  {
    try{
      if (codigo!=null)
      {
        const l:Laboratorio= this.laboratorios.find(l=>l.codigoLaboratorio===codigo);
        return l.nombre;
      }
      return "";
    }catch(Exception){
      return "";
    }    
  }

  getTipoPago(tipo: number) {
    return TipoPago[tipo];
  }

  getTipoAerovale() {
    return TipoAerovale[this.aerovaleDetalle.tipoAerovale];
  }

  getTipoVuelo(tipo: number) {
    return TipoVuelo[tipo];
  }

  getEstadoPruebaLaboratorio(estado: EstadoPruebaLaboratorio): string {
    return EstadoPruebaLaboratorio[estado];
  }

  capturarImagenAerovale(capture) {    
    if(capture) {
      const element = document.getElementById("aerovalePrint");

      html2canvas(element, {
          allowTaint: false,
          useCORS: true
        }).then( canvas => {
          canvas.toBlob( () => {
              const base64 = canvas.toDataURL("image/jpg");
              this.uploadImage(base64);                            
          },'image/jpg');
        });
    }
  }

  async uploadImage(b64img: string) {
    const archivo:string='AevAnulado_'+this.aerovaleDetalle.id+'.jpg'
    const file = await this.urltoFile(b64img,archivo,this.base64MimeType(b64img));

    // autosave
    /*const blob = new Blob([file], { type: 'application/jpg;' });
      saveAs(blob, 'AevAnulado_'+this.aerovaleDetalle.id+'.jpg');*/
    console.log("file: ", file);
    this.ranchoService.setArchivoAerovaleAnulado(file);
  }
  
  //return a promise that resolves with a File instance
  urltoFile(url, filename, mimeType){
      return (fetch(url)
          .then(function(res){return res.arrayBuffer();})
          .then(function(buf){return new File([buf], filename,{type:mimeType});})
      );
  }
  
  //return mime Type of bs64
  base64MimeType(encoded) {
      let result = null;
    
      if (typeof encoded !== 'string') {
        return result;
      }
    
      const mime = encoded.match(/data:([a-zA-Z0-9]+\/[a-zA-Z0-9-.+]+).*,.*/);
    
      if (mime && mime.length) {
        result = mime[1];
      }
    
      return result;
  }
}




